"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
var _MessageCard = _interopRequireDefault(require("../../components/Cards/MessageCard"));
var Theme = _interopRequireWildcard(require("../../theme"));
var _Classes = _interopRequireDefault(require("./Classes"));
var _Divisions = _interopRequireDefault(require("./Divisions"));
var _Loader = _interopRequireDefault(require("../../components/Loader"));
var _i18n = _interopRequireDefault(require("../../localization/i18n"));
var _tokens = _interopRequireDefault(require("../../localization/tokens"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var ClassesDivisions = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2["default"])(ClassesDivisions, _PureComponent);
  function ClassesDivisions() {
    (0, _classCallCheck2["default"])(this, ClassesDivisions);
    return _callSuper(this, ClassesDivisions, arguments);
  }
  (0, _createClass2["default"])(ClassesDivisions, [{
    key: "render",
    value: function render() {
      var _this = this;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, this.props.isMasterSite && (this.props.isQuote || this.props.isRevision) ? /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, this.props.step <= 3 ? /*#__PURE__*/_react["default"].createElement(_MessageCard["default"], {
        title: _i18n["default"].t(_tokens["default"].titles.classesAndDivisions),
        subtitle: "".concat(_i18n["default"].t(_tokens["default"].labels.classesAndDivisions.managementHeader), " ").concat(this.props.isRevision ? _i18n["default"].t(_tokens["default"].labels.quotes.revision) : _i18n["default"].t(_tokens["default"].labels.quotes.quote), " ").concat(_i18n["default"].t(_tokens["default"].labels.classesAndDivisions.managementNote))
      }) : this.props.isQuote ? /*#__PURE__*/_react["default"].createElement(_MessageCard["default"], {
        title: _i18n["default"].t(_tokens["default"].titles.classesAndDivisions),
        subtitle: _i18n["default"].t(_tokens["default"].labels.classesAndDivisions.pricingNote),
        btn: true,
        btnName: _i18n["default"].t(_tokens["default"].buttons.setQuoteBack),
        btnOnClick: function btnOnClick() {
          return _this.props.setState(2);
        }
      }) : null) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, this.props.step <= 3 ? /*#__PURE__*/_react["default"].createElement(_MessageCard["default"], {
        title: _i18n["default"].t(_tokens["default"].titles.classesAndDivisions),
        subtitle: _i18n["default"].t(_tokens["default"].labels.classesAndDivisions.managementNoteDivision)
      }) : /*#__PURE__*/_react["default"].createElement(_MessageCard["default"], {
        title: _i18n["default"].t(_tokens["default"].titles.classesAndDivisions),
        subtitle: _i18n["default"].t(_tokens["default"].labels.classesAndDivisions.reviewNote)
      })), /*#__PURE__*/_react["default"].createElement(_Classes["default"], {
        classData: this.props.classData,
        editClass: this.props.editClass,
        addClass: this.props.addClass,
        removeClass: this.props.removeClass,
        isQuote: this.props.isQuote,
        isRevision: this.props.isRevision,
        step: this.props.step,
        isMasterSite: this.props.isMasterSite,
        loading: this.props.loading,
        whitelabel: this.props.whitelabel,
        currentAccountMeta: this.props.currentAccountMeta,
        language: this.props.language || "en"
      }), /*#__PURE__*/_react["default"].createElement(_Divisions["default"], {
        divisions: this.props.divisions,
        editDivision: this.props.editDivision,
        addDivision: this.props.addDivision,
        removeDivision: this.props.removeDivision,
        validateBankingDetails: this.props.validateBankingDetails,
        bankingDetailsVerifying: this.props.bankingDetailsVerifying,
        isQuote: this.props.isQuote,
        isRevision: this.props.isRevision,
        step: this.props.step,
        isMasterSite: this.props.isMasterSite,
        loading: this.props.loading,
        whitelabel: this.props.whitelabel,
        currentAccountMeta: this.props.currentAccountMeta,
        language: this.props.language || "en"
      }), this.props.loading && /*#__PURE__*/_react["default"].createElement(_Loader["default"], {
        whitelabel: this.props.whitelabel
      }));
    }
  }]);
  return ClassesDivisions;
}(_react.PureComponent);
var _default = exports["default"] = ClassesDivisions;